export default {
    Landline: 1,
    TollFree: 2,
    HostedNumber: 3
};
